
<style lang="scss" scope>
.ivu-mt,
.ivu-mt-16 {
  margin-top: 16px !important;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.flex {
  display: flex !important;
  width: 100%;
}

.flex-warp {
  flex-wrap: wrap;
}

.mr1 {
  margin-right: 1rem;
  word-wrap: +break-word;
  word-break: +norm;
}

.flexs {
  display: flex !important;
  width: 15%;
}
</style>

<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar"  >
      <div class="flex flex-warp">
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">用户Id：</p>
          <el-input placeholder="请输入用户Id" v-model="search_data.app_user_id" class="input-with-select" style="width: 76%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">员工名：</p>
          <el-input placeholder="请输入员工名" v-model="search_data.admin_name" class="input-with-select" style="width: 76%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <!-- <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属APP：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.app_type" placeholder="全部" clearable @change="changes" style="width: 100%;">
              <el-option v-for="item in app_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div> -->
        <!-- <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属公司：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.corp_id" placeholder="全部" clearable @change="changes" style="width: 100%;">
              <el-option v-for="item in corp_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div> -->
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属部门：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.depart_id" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in depart_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属小组：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.group_id" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in group_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">日期：</p>
          <div class="l-show-more-search">
            <el-date-picker v-model="value2_check" style="width: 100%;"  type="datetimerange" @blur="onPick(false)"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
              @change="onPick(false)"></el-date-picker>
          </div>
        </div>

        <!-- <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1"></p>
          <div class="l-show-more-search">
          </div>
      </div> -->

      <div class="flexs items-center ivu-mt ivu-mr">
        <p class="mr1"></p>
        <div class="l-show-more-search" style="width: 76%;">
            <el-button type="default" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
          </div>
        </div>


      </div>

    </div>
  <l-table :data="data" v-loading="loading" row-key="id">
    <el-table-column fixed prop="index" label="序号" width="80"> </el-table-column>
      <el-table-column prop="app_id" label="归属平台" min-width="140" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ APP_TYPE[row.app_id] }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="corp_name" label="员工公司" min-width="160" show-overflow-tooltip> </el-table-column> -->
      <el-table-column prop="depart_name" label="员工部门" min-width="160" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="group_name" label="员工小组" min-width="160" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="admin_name" label="员工名" min-width="160" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="gold" label="代充金币" min-width="160" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="DisplayId" label="代充用户ID" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="app_user_name" label="代充用户昵称" min-width="160" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="AccountId" label="操作人" min-width="160" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="add_time" label="时间" min-width="200" show-overflow-tooltip> </el-table-column>
    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
      :current-page.sync="page"></l-page>

    <!--详情-->
    <!-- <l-dialog :visible.sync="info_visible" title="详情" width="1200px">
                  <l-logs-info :visible.sync="info_visible" :row="info_row" />
                </l-dialog> -->

  </el-card>
</template>

<script>
import Vue from "vue";
import { APP_TYPE, PAY_TYPE } from "../appUser/state";
export default {
  name: "l-appUser-admin",
  components: {

  },
  // computed: {
  //   hasId() {
  //     return this.$props.info_app_user_id !== null;
  //   },
  // },
  data() {
    return {
      box: 1,
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,

      info_visible: false, //是否显示编辑
      info_row: 0,
      APP_TYPE: APP_TYPE,
      PAY_TYPE: PAY_TYPE,
      //搜索
      search_visible: false,
      site_list: [],
      search_data: {
        app_user_id: "",
        // info_app_user_id : "",
        admin_name: "",
        app_type: "",
        start_time: "",
        end_time: "",
        corp_id: "",
        depart_id: "",
        group_id: ""
      },
      rel_search_data: {},
      show_more_search: false,
      value2: "",
      value2_check: "",

      corp_list: [],
      depart_list: [],
      group_list: [],
      app_list: []
    };
  },

  mounted() {
    // this.search_data.info_app_user_id = this.$props.info_app_user_id ;
    this.getList();
    this.getSearchData();
  },

  methods: {
    getSearchData() {
      // this.loading = true;
      this.$_invoke("adminUser_getSearchData", {
        corp_id: this.search_data.corp_id,
        depart_id: this.search_data.depart_id,
        group_id: this.search_data.group_id,
      })
        .then((ret) => {
      
          // this.corp_list = ret.corp_list;
          this.depart_list = ret.depart_list;
          this.group_list = ret.group_list;
          this.app_list = ret.app_list;
        })
        .finally(() => {
          // this.loading = false;
        });

    },
    // 点击 更改部门
    changes() {
      this.getList();
      this.getSearchData();
    },
    // onPick(cant) {
    //   if (!this.value2) {
    //     // this.value2 = "";
    //     // this.search_data.start_time = "";
    //     // this.search_data.end_time = "";
    //   } else {
    //     this.search_data.start_time = this.value2[0];
    //     this.search_data.end_time = this.value2[1];
    //   }
    //   if (!cant) {
    //     this.onSearch();
    //   }
    // },

    onPick(cant) {
      if (!this.value2_check) {
        this.value2_check = "";
        this.search_data.start_time = "";
        this.search_data.end_time = "";
      } else {
        this.search_data.start_time = this.value2_check[0];
        this.search_data.end_time = this.value2_check[1];
      }
      if (!cant) {
        this.onSearch();
      }
    },
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("appUserAdmin_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.search_data,
      })
        .then((ret) => {
          console.log(ret.data);
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //显示详情
    showInfo(row) {
      this.info_row = row;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },

    //清除搜索数据
    clearSearch() {
      this.search_data.app_user_id = "";
      this.search_data.admin_name = "";
      this.search_data.app_type = "";
      this.search_data.corp_id = "";
      this.search_data.depart_id = "";
      this.search_data.group_id = "";
      this.search_data.end_time = "";
      this.search_data.start_time = "";
      this.search_data.start_time = "";

      this.corp_list = [];
      this.depart_list = [];
      this.group_list = [];
      this.app_list = [];
      this.getSearchData();
      this.getList();
    },
  },
};
</script>
